


















import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { HisInformationListItem } from "../../../domain/his/HisInformationListItem";
import { HisInformationItem } from "../../../domain/his";
import { StandardOption } from "../../system/selectors/mixins";
import { ModelEditableMixin } from "../../system/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  }
})

export default class DiseaseFilter extends Mixins(ModelEditableMixin) {
  editingSource: (s: HisInformationListItem) => boolean;

  @Prop()
  options: HisInformationListItem[];

  data(): any {
    return {
      outcomeOptions: [new StandardOption<string>("指定なし", "")],
      outcome: "",
      isMainDisease: false,
    };
  }
  outcomeOptions: StandardOption<string>[];
  outcome: string;
  isMainDisease: boolean;

  mounted() {
    this.setOptions();
  }

  createFilter(): (s: HisInformationListItem) => boolean {
    return s => (!this.outcome || this.contains(s.items, "DISEASE_TRANSFER", this.outcome))
             && (!this.isMainDisease || this.contains(s.items, "DISEASE_MAIN", "1"));
  }

  contains(items: HisInformationItem[], name: string, value: string): boolean {
    return Enumerable.from(items).any(i => (i.name === name) && (i.value === value));
  }

  get outcomes(): StandardOption<string>[] {
    return this.outcomeOptions;
  }
 
  get selectedOutcome(): string {
    return this.outcome;
  }

  set selectedOutcome(value: string) {
    this.outcome = value;
    this.editingSource = this.createFilter();
  }

  setOptions(): void {
    if (!this.options) { return; }
    this.outcomeOptions = Enumerable.from(this.options)
      .selectMany(i => i.items)
      .where(x => x.name === "DISEASE_TRANSFER")
      .distinct(y => y.value)
      .select(o => new StandardOption<string>(o.value, o.value)).toArray();
    this.outcomeOptions.unshift(new StandardOption<string>("指定なし", ""));
  }

  @Watch("isMainDisease")
  onIsMainDisease(newValue: string, oldValue: string) {
    this.editingSource = this.createFilter();
  }
}
